module.exports = __webpack_public_path__ + "img/jigar-pro.346766ba.jpg";